import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  changeCloneStatusAsync,
  deleteCloneAsync,
  getMyClonesAsync,
} from "./actions";
import { MyClonesState } from "./slice";

type Reducer = (builder: ActionReducerMapBuilder<MyClonesState>) => void;

export const getMyClonesReducer: Reducer = (builder) => {
  builder.addCase(getMyClonesAsync.pending, (state) => {
    state.myClones.isLoading = true;
  });

  builder.addCase(getMyClonesAsync.fulfilled, (state, actions) => {
    state.myClones.isLoading = false;
    state.myClones.data = actions.payload;
  });

  builder.addCase(getMyClonesAsync.rejected, (state) => {
    state.myClones.isLoading = false;
    state.myClones.data = null;
  });
};

export const deleteCloneReducer: Reducer = (builder) => {
  builder.addCase(deleteCloneAsync.fulfilled, (state, actions) => {
    const deletedCloneId = actions.payload;

    state.myClones.data.results = state.myClones.data.results.filter(
      ({ id }) => deletedCloneId !== id
    );
  });
};

export const changeCloneStatusReducer: Reducer = (builder) => {
  builder.addCase(changeCloneStatusAsync.fulfilled, (state, actions) => {
    const { id: cloneId, status } = actions.payload;

    const requiredСlone = state.myClones.data.results.find(
      ({ id }) => cloneId === id
    );
    requiredСlone.status = status;
  });
};
